import React from 'react';
import './Price.scss';

interface PriceProps {
  hidden?: boolean;
  inverse?: boolean;
  savings?: boolean;
  small?: boolean;
}

export const Price: React.FC<PriceProps> = ({
  children,
  hidden,
  inverse,
  savings,
  small
}) => {
  return (
    <span
      className={`ads-price 
        ${hidden ? 'hidden' : ''}
        ${inverse ? 'ads-price--inverse' : ''}
        ${savings ? 'ads-price--savings' : ''}
        ${small ? 'ads-price--small' : ''} 
      `}
      aria-label="Price"
      data-testid="ads-price"
    >
      {children}
    </span>
  );
};
